import { FC } from "react";
import { IconPropsType } from ".";

export const CloseEye: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 9.75C8.99741 9.75 9.9428 9.5687 10.8025 9.2949C9.92909 9.86545 8.97522 10.25 8 10.25C7.02478 10.25 6.07091 9.86546 5.1975 9.2949C6.0572 9.5687 7.00259 9.75 8 9.75Z"
        stroke={props.color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
